import { activityFeedRootSaga } from '@app/components/ActivityFeed/modules/activityFeed'
import { assignmentFormRootSaga } from '@app/components/AssignmentForm/modules/assignmentForm'
import { changePasswordRootSaga } from '@app/components/ChangePasswordModal/modules/changePassword'
import { commentEditorRootSaga } from '@app/components/CommentEditor/modules/commentEditor'
import { contextReminderRootSaga } from '@app/components/ContextReminder/modules/contextReminder'
import { criticalDatesEditRootSaga } from '@app/components/CriticalDatesEditModal/modules/criticalDatesEdit'
import { dueDiligenceItemEditRootSaga } from '@app/components/DueDiligenceItemEdit/modules/dueDiligenceItemEdit'
import { feedbackRootSaga } from '@app/components/Feedback/modules/feedback'
import { feedItemsRootSaga } from '@app/components/FeedItem/modules/feedItems'
import { feedItemEditorRootSaga } from '@app/components/FeedItemEditor/modules/feedItemEditor'
import { fileUploadRootSaga } from '@app/components/FileUpload/modules/fileUpload'
import { globalSearchRootSaga } from '@app/components/GlobalSearch/modules/globalSearch'
import { listingEditRootSaga } from '@app/components/ListingEdit/modules/listingEdit'
import { mentionEditorRootSaga } from '@app/components/MentionEditor/modules/mentionEditor'
import { preferencesEditRootSaga } from '@app/components/PreferencesModal/modules/preferencesEdit'
import { quickAddRootSaga } from '@app/components/QuickAddModal/modules/quickAdd'
import { shareAttachmentRootSaga } from '@app/components/ShareAttachmentModal/modules/shareAttachment'
import { signTransferRootSaga } from '@app/components/SignTransferModal/modules/signTransfer'
import { transactionRootSaga } from '@app/components/TransactionHistoryModal/modules/transactionHistory'
import { forgotPasswordRootSaga } from '@app/routes/Account/ForgotPassword/modules/forgotPassword'
import { loginRootSaga } from '@app/routes/Account/Login/modules/login'
import { guestListRootSaga } from '@app/routes/Administration/Guests/List/modules/guestList'
import { guestViewRootSaga } from '@app/routes/Administration/Guests/View/modules/guestView'
import { signTypeListRootSaga } from '@app/routes/Administration/SignTypes/List/modules/signTypesList'
import { teamsListRootSaga } from '@app/routes/Administration/Teams/List/modules/teamsList'
import { teamViewRootSaga } from '@app/routes/Administration/Teams/View/modules/teamView'
import { userEditRootSaga } from '@app/routes/Administration/Users/Edit/modules/userEdit'
import { usersListRootSaga } from '@app/routes/Administration/Users/List/modules/userList'
import { userViewRootSaga } from '@app/routes/Administration/Users/View/modules/userView'
import { leadsListRootSaga } from '@app/routes/Brokerage/Leads/List/modules/leadsList'
import { listingsListRootSaga } from '@app/routes/Brokerage/Listings/List/modules/listingsList'
import { listingSelectorRootSaga } from '@app/components/ListingSelector/modules/listingSelector'
import { listingRootSaga } from '@app/routes/Brokerage/Listings/View/modules/listing'
import { pipelineListRootSaga } from '@app/routes/Brokerage/Pipeline/List/modules/pipelineList'
import { pipelineRootSaga } from '@app/routes/Brokerage/Pipeline/View/modules/pipeline'
import { assignmentsCalendarRootSaga } from '@app/routes/Calendars/Assignments/modules/assignmentsCalendar'
import { brokeragePipelinesCalendarRootSaga } from '@app/routes/Calendars/BrokeragePipelines/modules/brokeragePipelinesCalendar'
import { dueDiligenceCalendarRootSaga } from '@app/routes/Calendars/DueDiligence/modules/dueDiligenceCalendar'
import { listingsCalendarRootSaga } from '@app/routes/Calendars/Listings/modules/listingsCalendar'
import { connectionEditRootSaga } from '@app/routes/Connections/Edit/modules/connectionEdit'
import { connectionsListRootSaga } from '@app/routes/Connections/List/modules/connectionsList'
import { connectionViewRootSaga } from '@app/routes/Connections/View/modules/connectionView'
import { cityEditRootSaga } from '@app/routes/Development/Cities/Edit/modules/cityEdit'
import { citiesListRootSaga } from '@app/routes/Development/Cities/List/modules/citiesList'
import { cityViewRootSaga } from '@app/routes/Development/Cities/View/modules/cityView'
import { clientEditRootSaga } from '@app/routes/Development/Clients/Edit/modules/clientEdit'
import { clientListRootSaga } from '@app/routes/Development/Clients/List/modules/clientsList'
import { developmentSiteEditRootSaga } from '@app/routes/Development/Clients/Sites/Edit/modules/developmentSiteEdit'
import { siteListRootSaga } from '@app/routes/Development/Clients/Sites/List/modules/siteList'
import { developmentSiteViewRootSaga } from '@app/routes/Development/Clients/Sites/View/modules/developmentSiteView'
import { clientDetailRootSaga } from '@app/routes/Development/Clients/View/modules/developmentClientDetail'
import { earnestMoneyListRootSaga } from '@app/routes/Development/EarnestMoney/List/modules/earnestMoneyList'
import { developmentProjectsListRootSaga } from '@app/routes/Development/Projects/List/modules/developmentProjectsList'
import { formsListRootSaga } from '@app/routes/Forms/List/modules/formsList'
import { mapViewRootSaga } from '@app/routes/Map/modules/mapView'
import { notificationsListRootSaga } from '@app/routes/Notifications/List/modules/notificationsList'
import { assignmentsListRootSaga } from '@app/routes/Personal/Assignments/List/modules/assignmentsList'
import { assignmentDetailRootSaga } from '@app/routes/Personal/Assignments/View/modules/assignmentDetail'
import { goalListRootSaga } from '@app/routes/Personal/Goals/List/modules/goalsList'
import { messageListRootSaga } from '@app/routes/Personal/Messages/List/modules/messagesList'
import { todoListRootSaga } from '@app/routes/Personal/Todos/List/modules/todoList'
import { pipelineEditRootSaga } from '@app/components/PipelineEdit/modules/pipelineEdit'
import { propertyEditRootSaga } from '@app/components/PropertyEdit/modules/propertyEdit'
import { propertiesListRootSaga } from '@app/routes/Properties/Properties/List/modules/propertiesList'
import { propertyRootSaga } from '@app/routes/Properties/Properties/View/modules/property'
import { earnestMoneyListReportRootSaga } from '@app/routes/Reports/EarnestMoney/List/modules/earnestMoneyList'
import { projectedEarningsRootSaga } from '@app/routes/Reports/ProjectedEarnings/List/modules/projectedEarnings'
import { projectedProfitRootSaga } from '@app/routes/Reports/ProjectedProfit/List/modules/projectedProfit'
import { signsListRootSaga } from '@app/routes/Reports/Signs/List/modules/signsList'
import { soldPropertiesListRootSaga } from '@app/routes/Reports/SoldProperties/List/modules/soldPropertiesList'
import { successStoriesListRootSaga } from '@app/routes/Properties/SuccessStories/List/modules/successStoriesList'
import { successStoryEditRootSaga } from '@app/routes/Properties/SuccessStories/Edit/modules/successStoriesEdit'
import { systemNotificationsRootSaga } from '@app/store/modules/systemNotifications'
import createSagaMiddleware, { Task } from 'redux-saga'
import { accountRootSaga } from './modules/account'
import { globalRootSaga } from './modules/global'

interface ISagaRegistry {
  [key: string]: Task
}

const sagaRegistry: ISagaRegistry = {}

export const sagaMiddleware = createSagaMiddleware()

export function injectSaga(key: string, saga: any) {
  if (sagaRegistry[key]) {
    sagaRegistry[key].cancel()
  }

  sagaRegistry[key] = sagaMiddleware.run(saga)
}

export function initializeSagas() {
  injectSaga('account', accountRootSaga)
  injectSaga('activityFeed', activityFeedRootSaga)
  injectSaga('assignmentDetail', assignmentDetailRootSaga)
  injectSaga('assignmentForm', assignmentFormRootSaga)
  injectSaga('assignmentsCalendar', assignmentsCalendarRootSaga)
  injectSaga('assignmentsList', assignmentsListRootSaga)
  injectSaga('brokeragePipelinesCalendar', brokeragePipelinesCalendarRootSaga)
  injectSaga('changePassword', changePasswordRootSaga)
  injectSaga('citiesList', citiesListRootSaga)
  injectSaga('cityEdit', cityEditRootSaga)
  injectSaga('cityView', cityViewRootSaga)
  injectSaga('clientDetail', clientDetailRootSaga)
  injectSaga('clientEdit', clientEditRootSaga)
  injectSaga('clientList', clientListRootSaga)
  injectSaga('commentEditor', commentEditorRootSaga)
  injectSaga('contextReminder', contextReminderRootSaga)
  injectSaga('connectionEdit', connectionEditRootSaga)
  injectSaga('connectionView', connectionViewRootSaga)
  injectSaga('connectionsList', connectionsListRootSaga)
  injectSaga('saveCriticalDatesEdit', criticalDatesEditRootSaga)
  injectSaga('developmentProjectsList', developmentProjectsListRootSaga)
  injectSaga('developmentSiteEdit', developmentSiteEditRootSaga)
  injectSaga('developmentSiteView', developmentSiteViewRootSaga)
  injectSaga('dueDiligenceCalendar', dueDiligenceCalendarRootSaga)
  injectSaga('dueDiligenceItemEdit', dueDiligenceItemEditRootSaga)
  injectSaga('earnestMoneyList', earnestMoneyListRootSaga)
  injectSaga('earnestMoneyListReport', earnestMoneyListReportRootSaga)
  injectSaga('feedItemEditor', feedItemEditorRootSaga)
  injectSaga('feedItems', feedItemsRootSaga)
  injectSaga('feedback', feedbackRootSaga)
  injectSaga('fileUpload', fileUploadRootSaga)
  injectSaga('forgotPassword', forgotPasswordRootSaga)
  injectSaga('formsList', formsListRootSaga)
  injectSaga('global', globalRootSaga)
  injectSaga('globalSearch', globalSearchRootSaga)
  injectSaga('goalList', goalListRootSaga)
  injectSaga('guestList', guestListRootSaga)
  injectSaga('guestView', guestViewRootSaga)
  injectSaga('leadsList', leadsListRootSaga)
  injectSaga('listing', listingRootSaga)
  injectSaga('listingEdit', listingEditRootSaga)
  injectSaga('listingsCalendar', listingsCalendarRootSaga)
  injectSaga('listingsList', listingsListRootSaga)
  injectSaga('listingSelector', listingSelectorRootSaga)
  injectSaga('login', loginRootSaga)
  injectSaga('mapView', mapViewRootSaga)
  injectSaga('mentionEditor', mentionEditorRootSaga)
  injectSaga('messageList', messageListRootSaga)
  injectSaga('notificatonsList', notificationsListRootSaga)
  injectSaga('pipeline', pipelineRootSaga)
  injectSaga('pipelineEdit', pipelineEditRootSaga)
  injectSaga('pipelineList', pipelineListRootSaga)
  injectSaga('preferencesEdit', preferencesEditRootSaga)
  injectSaga('projectedEarnings', projectedEarningsRootSaga)
  injectSaga('projectedProfit', projectedProfitRootSaga)
  injectSaga('propertiesList', propertiesListRootSaga)
  injectSaga('property', propertyRootSaga)
  injectSaga('propertyEdit', propertyEditRootSaga)
  injectSaga('quickAdd', quickAddRootSaga)
  injectSaga('shareAttachment', shareAttachmentRootSaga)
  injectSaga('signTransfer', signTransferRootSaga)
  injectSaga('signTypeList', signTypeListRootSaga)
  injectSaga('signsList', signsListRootSaga)
  injectSaga('siteList', siteListRootSaga)
  injectSaga('soldPropertiesList', soldPropertiesListRootSaga)
  injectSaga('successStoriesList', successStoriesListRootSaga)
  injectSaga('successStoryEdit', successStoryEditRootSaga)
  injectSaga('systemNotifications', systemNotificationsRootSaga)
  injectSaga('teamView', teamViewRootSaga)
  injectSaga('teamsList', teamsListRootSaga)
  injectSaga('todoList', todoListRootSaga)
  injectSaga('transaction', transactionRootSaga)
  injectSaga('userEdit', userEditRootSaga)
  injectSaga('userView', userViewRootSaga)
  injectSaga('usersList', usersListRootSaga)
}
